@if (audioChannelStates && audioChannelGroupStates && scenarioRecording) {
	<div class="paneContentNoPadding">
		@if (!scenarioRecording?.isMultiChannelAudio) {
			<div class="micGroupContainer">
				<div class="device master" *ngVar="audioChannelStates[setting.singleChannelId] as audioChannelState">
					<div class="name">
						<mat-icon fontSet="fas" fontIcon="fa-speaker" inline style="font-size: 30px; text-align: left" />
						<div class="nameDesc">
							{{ T.SHARED_AUDIO_CHANNEL_CONTROL_PANEL_MASTER | translate }}
						</div>
					</div>
					<div class="masterSlider">
						<mat-slider discrete style="width: 100%" color="accent">
							<input
								matSliderThumb
								[value]="audioChannelState?.actualVolume ?? 100"
								(valueChange)="setVolume(setting.singleChannelId, null, $event)"
							/>
						</mat-slider>
					</div>
					<div class="actions">
						@if (showMute) {
							<button
								color="accent"
								mat-icon-button
								(click)="toggleMute(setting.singleChannelId, null)"
								[class.on]="audioChannelState.muted"
							>
								<mat-icon [svgIcon]="audioChannelState.muted ? 'audio_speaker_not' : 'audio_speaker'" />
							</button>
						}
					</div>
				</div>
			</div>
		}
		@if (scenarioRecording?.isMultiChannelAudio) {
			<mat-tab-group [mat-stretch-tabs]="false" color="accent" [dynamicHeight]="true">
				@for (audioChannelGroup of audioChannelGroups; track audioChannelGroup) {
					<mat-tab label="{{ audioChannelGroup.name | translate }}">
						<ng-container *ngVar="audioChannelGroupStates[audioChannelGroup.id] as audioGroupChannelState">
							<div class="tabContent">
								<div class="micGroupContainer">
									<div class="device master">
										<div class="name">
											<mat-icon
												fontSet="fas"
												fontIcon="fa-speaker"
												inline
												style="font-size: 30px; text-align: left"
											/>
											<div class="nameDesc">
												{{ T.SHARED_AUDIO_CHANNEL_CONTROL_PANEL_MASTER | translate }}
											</div>
										</div>
										<div class="masterSlider">
											<mat-slider discrete style="width: 100%" color="accent">
												<input
													matSliderThumb
													[value]="audioGroupChannelState?.volume ?? 100"
													(valueChange)="setGroupVolume(audioChannelGroup.id, $event)"
												/>
											</mat-slider>
										</div>
										<div class="actions">
											@if (showSolo) {
												<button
													color="accent"
													mat-icon-button
													(click)="toggleGroupSolo(audioChannelGroup.id)"
													[class.onSolo]="audioGroupChannelState?.solo"
												>
													<mat-icon svgIcon="audio_solo" />
												</button>
											}
											@if (showMute) {
												<button
													color="accent"
													mat-icon-button
													(click)="toggleGroupMute(audioChannelGroup.id)"
													[class.on]="audioGroupChannelState?.muted"
												>
													<mat-icon
														[svgIcon]="audioGroupChannelState?.muted ? 'audio_speaker_not' : 'audio_speaker'"
													/>
												</button>
											}
										</div>
									</div>
									<!--					<pre>-->
									<!--						{{audioChannelGroup | json}}-->
									<!--					</pre>-->
									@for (
										audioChannel of audioChannelGroup["channels"]
											| castToAudioInputChannels
											| filterInvisibleAudioChannels;
										track audioChannel
									) {
										<div class="device" [style.order]="audioChannel.guiPosition">
											<ng-container *ngVar="audioChannelStates[audioChannel.id] as audioChannelState">
												<div class="name">
													<mat-icon
														fontSet="fas"
														[fontIcon]="getFontIcon(audioChannel.icon)"
														inline
														[style.fontSize]="'24px'"
														style="text-align: left"
													/>
													<div class="nameDesc">
														{{ audioChannel.displayName }}
													</div>
												</div>
												<div class="slider normalSlider">
													<mat-slider discrete style="width: 100%" color="accent">
														<input
															matSliderThumb
															[value]="audioChannelState?.volume ?? 100"
															(valueChange)="setVolume(audioChannel.id, audioChannelGroup.id, $event)"
														/>
													</mat-slider>
												</div>
												<div class="actions">
													@if (showSolo) {
														<button
															color="accent"
															mat-icon-button
															(click)="toggleSolo(audioChannel.id, audioChannelGroup.id)"
															[class.onSolo]="audioChannelState?.solo"
														>
															<mat-icon svgIcon="audio_solo" />
														</button>
													}
													@if (showMute) {
														<button
															color="accent"
															mat-icon-button
															[class.on]="audioChannelState?.muted"
															(click)="toggleMute(audioChannel.id, audioChannelGroup.id)"
														>
															<mat-icon
																[svgIcon]="audioChannelState?.muted ? 'audio_speaker_not' : 'audio_speaker'"
															/>
														</button>
													}
												</div>
											</ng-container>
										</div>
									}
								</div>
							</div>
						</ng-container>
					</mat-tab>
				}
			</mat-tab-group>
		}
	</div>
}
